export default __webpack_public_path__ + "static/media/akar-icons_linkedin-fill.1cb2a199.svg";